import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Arguments } from "../components/Arguments";
import { Collections } from "../components/Collections";
import { Selection } from "../components/Selection";
import { Maison } from "../components/Maison";
import { Experience } from "../components/Experience";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <Arguments />
      <Collections />
      <Selection />
      <Maison />
      <Experience />
    </main>
  );
}
